// React Imports
import { ReactElement } from "react";

// Third Party Library Imports
import clsx from "clsx";
import { Tooltip } from "antd";

type LabelProperties = {
  text: string;
  style?: React.CSSProperties;
  className?: string;
  required?: boolean;
};

const Label: React.FC<LabelProperties> = ({
  text,
  style,
  className,
  required
}: LabelProperties): ReactElement => (
  <Tooltip title={text}>
    <label
      style={{
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        minHeight: "2.4em",
        ...style,
      }}
      className={clsx(
        "mb-[5px] text-black-300 text-xs font-medium",
        className
      )}
    >
      <span>{text}</span>
      {required && <span className="text-red-500 ps-1">*</span>}
    </label>
  </Tooltip>
);

export default Label;
